import React, { useEffect, useState } from 'react';
import api from '../api';
import Modal from '../Modal';
import Confirm from '../Confirm';
import { FaPlus, FaTrash } from 'react-icons/fa6';
import { useLang } from '../Layout';

const CATEGORIES = { material: 'মাল', labor: 'মজুরি', transport: 'পরিবহন', other: 'অন্যান্য' };
const CATEGORIES_EN = { material: 'Material', labor: 'Labor', transport: 'Transport', other: 'Other' };

const T = {
  bn: { title: 'খরচ', sub: 'মোট:', newBtn: 'নতুন খরচ', desc: 'বিবরণ', type: 'ধরন', amount: 'টাকা (৳)', date: 'তারিখ', save: 'সংরক্ষণ করুন', delTitle: 'খরচ মুছুন?', delMsg: 'খরচটি মুছে যাবে।', empty: 'এখনো কোনো খরচ নেই।', required: 'Required', select: '— নির্বাচন করুন —' },
  en: { title: 'Expenses', sub: 'Total:', newBtn: 'Add Expense', desc: 'Description', type: 'Category', amount: 'Amount (৳)', date: 'Date', save: 'Save', delTitle: 'Delete Expense?', delMsg: 'will be deleted.', empty: 'No expenses yet.', required: 'Required', select: '— Select —' },
};

export default function Expenses() {
  const { lang } = useLang(); const t = T[lang]; const cats = lang === 'en' ? CATEGORIES_EN : CATEGORIES;
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [show, setShow] = useState(false);
  const [confirmDel, setConfirmDel] = useState(null);
  const [form, setForm] = useState({ title: '', category: 'other', amount: '', note: '', date: new Date().toISOString().slice(0, 10) });

  const load = () => api.get('/owner/expenses').then(({ data }) => { setList(data.expenses); setTotal(data.total); }).catch(() => {});
  useEffect(() => { load(); }, []);

  async function save(e) {
    e.preventDefault();
    await api.post('/owner/expenses', form);
    setShow(false);
    setForm({ title: '', category: 'other', amount: '', note: '', date: new Date().toISOString().slice(0, 10) });
    load();
  }
  async function del(id) { await api.delete(`/owner/expenses/${id}`); load(); }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-xl font-semibold text-[#0F172A]">{t.title}</h1>
          <p className="text-sm text-[#475569]">{t.sub} <span className="font-bold text-[#0F172A]">৳{total.toLocaleString()}</span></p>
        </div>
        <button className="btn-primary flex items-center gap-2 text-sm" onClick={() => setShow(true)}><FaPlus /> {t.newBtn}</button>
      </div>

      {/* Charm table */}
      <div className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] overflow-hidden">
        <table className="charm-table">
          <thead><tr><th>{t.desc}</th><th>{t.type}</th><th>{t.date}</th><th className="text-right">{t.amount}</th><th></th></tr></thead>
          <tbody>
            {list.map((x) => (
              <tr key={x.id}>
                <td><span className="font-medium text-[#0F172A]">{x.title}</span></td>
                <td className="text-[#475569]">{cats[x.category] || x.category}</td>
                <td className="text-[#475569]">{x.date}</td>
                <td className="text-right font-bold text-[#0F172A]">৳{Number(x.amount).toLocaleString()}</td>
                <td><button onClick={() => setConfirmDel(x)} className="p-1.5 text-[#94A3B8] hover:text-[#F59E0B] hover:bg-[#FFFBEB] rounded-lg transition"><FaTrash className="text-xs" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <div className="text-center py-12 text-[#94A3B8] text-sm">{t.empty}</div>}
      </div>

      <Confirm open={!!confirmDel} onClose={() => setConfirmDel(null)} onConfirm={() => del(confirmDel.id)} title={t.delTitle} message={`"${confirmDel?.title}" ${t.delMsg}`} />

      <Modal open={show} onClose={() => setShow(false)} title={t.newBtn}>
        <form onSubmit={save} className="space-y-4">
          <div>
            <label className="label">{t.desc} <span className="text-[#F59E0B]">*</span></label>
            <input className="input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
          </div>
          <div>
            <label className="label">{t.type}</label>
            <select className="input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
              {Object.entries(cats).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
          <div>
            <label className="label">{t.amount} <span className="text-[#F59E0B]">*</span></label>
            <input className="input" type="number" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} required />
          </div>
          <div>
            <label className="label">{t.date}</label>
            <input className="input" type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
          </div>
          <button className="btn-primary w-full">{t.save}</button>
        </form>
      </Modal>
    </div>
  );
}
